import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";

// Pages
import HomePage from "./components/Home/Home"
import AboutPage from "./components/AboutUs/AboutUs";
import ContactUs from "./components/ContactUs/ContactUs";
// import TopBar from "./components/TopBar/TopBar";





//Service 
import Metal3DPrinting from "./components/Services/Metal3DPrinting/Metal3DPrinting";
import CNC from "./components/Services/CNC/CNC";
import VC from "./components/Services/VC/VC";
import IM from "./components/Services/IC/IM";
import MM from "./components/Services/MM/MM";
import RE from "./components/Services/RE/RE";
import Metal3D from "./components/Services/M3D/M3D";
import CADModelling from "./components/Services/CAD/CAD";
import Machine from "./components/Services/Machine/Machine";
import PT from "./components/Services/PT/PT";
import VacumF from "./components/Services/VacuumF/VacuumF";
import Sspartone from "./components/Services/Sspartone/Sspartone";
import Ssparttwo from "./components/Services/Ssparttwo/Ssparttwo";
import Msone from "./components/Services/Msone/Msone";
import RFQ from "./components/RequestAQuote/RAQ"



function App() {
  return (
    <Router>
      <Navbar />

      <div className="page-container">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactUs />} />

          {/* Services */}
          <Route path="/AdditiveManufacturing" element={<Metal3DPrinting />} />
          <Route path="/CNC" element={<CNC />} />
          <Route path="/VC" element={<VC />} />
          <Route path="/IM" element={<IM />} />
          <Route path="/MM" element={<MM />} />
          <Route path="/RE" element={<RE />} />
          <Route path="/Metal3D" element={<Metal3D />} />
          <Route path="/CADModelling" element={<CADModelling />} />
          <Route path="/Machine" element={<Machine />} />
          <Route path="/PT" element={<PT />} />
          <Route path="/VacumF" element={<VacumF/>}/>
          <Route path="/Sspartone" element={<Sspartone/>}/>
          <Route path="/Ssparttwo" element={<Ssparttwo/>}/>
          <Route path="/Msone" element={<Msone/>}/>
          <Route path="/RFQ" element={<RFQ/>}/>

        </Routes>
      </div>

      <Footer />
    </Router>
  );
}

export default App;